module.exports = __webpack_public_path__ + "img/plan-building-4.bc32639e.jpg";